<rask-toggle-panel #togglePanel
  [defaultExpanded]="true"
  [enableBackdrop]="true" label="Skogsvård" [noPadding]="true" (onToggle)="onToggle($event)">
  <ng-container header>
    <rask-action-button
      aid="buttonCreateSkogsvard"
      [disabled]="(!kontraktIsViol3() && !isSkogsvardFPVKontrakt()) || (isReadonly$ | async) || isVacsAvraknatOrAvslutat()"
      alignment="right"
      icon="far fa-hand-holding-seedling"
    (click)="addSkogsvard()">Lägg till ny skogsvård</rask-action-button>

    <rask-inline-toast
      class="right"
      [showToast]="skogsvardAdded$"
      [viewInMillisseconds]="1000">
      Skogsvård har lagts till på kontraktet
    </rask-inline-toast>
  </ng-container>
  @for (entity of skogsvardListSorted; track trackByFn(i, entity); let i = $index) {
    <div>
      <rask-skogsvard-item [entity]="entity"
        [index]="i">
      </rask-skogsvard-item>
    </div>
  }
</rask-toggle-panel>